export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
              关于6080影视
            </h2>
            <p className="text-sm text-foreground-500">
              专注综艺，用心服务每一位追综爱好者
            </p>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-300/20 p-6 md:p-10">
            <div className="space-y-5 text-sm text-foreground-400 leading-relaxed">
              <p>
                <strong className="text-foreground-200 font-heading">6080影视</strong> 创办于2020年，是国内领先的综艺节目高清免费在线观看平台。
                我们深知追综艺的快乐不容等待，因此始终坚持以最快的更新速度、最清晰的画质和最流畅的播放体验，
                为广大综艺爱好者打造一站式的追综服务。
              </p>
              <p>
                平台收录热门综艺、搞笑综艺、真人秀、音乐节目等全品类综艺内容超过<strong className="text-primary-400">10000小时</strong>，
                涵盖国内各大卫视与主流网络平台的优质综艺资源。从经典回顾到最新档期，从户外竞技到音乐竞演，
                从搞笑喜剧到情感观察，无论你喜欢哪种类型，这里都能满足你。
              </p>
              <p>
                我们相信好的内容应该被更多人看到。6080影视坚持<strong className="text-accent-400">免费、高清、无广告</strong>的服务理念，
                无需注册登录，无需付费会员，打开网站即点即看。我们通过技术创新持续优化播放体验，
                独家CDN加速技术和智能预加载算法确保99.9%的流畅播放率，让你追综艺不卡顿、不等待。
              </p>
              <p>
                每天<strong className="text-primary-400">30+档</strong>热门综艺持续更新，最快30分钟内同步卫视播出。
                同时提供移动端APP，支持离线缓存、投屏电视、倍速播放等实用功能，让追综不再受时间和空间限制。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-300/20">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-400 font-heading">2020</div>
                <div className="text-xs text-foreground-600 mt-1 whitespace-nowrap">创始年份</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400 font-heading">10000+</div>
                <div className="text-xs text-foreground-600 mt-1 whitespace-nowrap">小时内容库</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-400 font-heading">500万+</div>
                <div className="text-xs text-foreground-600 mt-1 whitespace-nowrap">月活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-400 font-heading">99.9%</div>
                <div className="text-xs text-foreground-600 mt-1 whitespace-nowrap">流畅播放率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}